import { type PropsWithChildren, useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { ErrorPage } from '@/components/ErrorPage';
import { LoaderFull } from '@/components/LoaderFull';
import { useGetAccountQuery } from '@/features/auth';
import { useAuth } from '@/features/auth/useAuth';

import { removeSecurityTokens } from './authUtils';

export const GuardSynapsAdmin: React.FC<
  PropsWithChildren<{
    loginPath: string;
  }>
> = ({ children, loginPath }) => {
  const { token } = useAuth();

  const me = useGetAccountQuery({
    enabled: !!token,
  });

  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if ((me.isError && me.error.response?.status === 401) || !token) {
      removeSecurityTokens();
      navigate(`${loginPath}?redirect=${pathname}`, { replace: true });
    }
  }, [
    pathname,
    loginPath,
    me.isError,
    me.error?.response?.status,
    navigate,
    token,
  ]);

  if (me.isError && me.error.response?.status !== 401) {
    return <ErrorPage errorCode={me.error.response?.status} />;
  }

  if (me.data) {
    return me.data.isSynapsAdmin ? (
      <>{children}</>
    ) : (
      <ErrorPage errorCode={403} />
    );
  }

  return <LoaderFull />;
};
